<!-- title -->
<h1 mat-dialog-title>Permissions</h1>

<!-- content -->
<mat-dialog-content>
    <h4>{{appLabels?.permissionsConfig?.permissionInfoMessage}}</h4>
    <div id="checklist">
        <!-- <mat-checkbox (change)="togglePermission($event)" [checked]="permissions.location"></mat-checkbox> -->
        <input id="01" type="checkbox" name="r" (click)="togglePermission('location', $event)"
            [checked]="permissions.location" [disabled]="permissions.location"
            *ngIf="!locationDisabled && this.enabledPermissions['location']" />
        <label for="01" style="display: flex;" *ngIf="!locationDisabled && this.enabledPermissions['location']">
            <img src="assets/images/location.gif" class="animated-gifs" alt="this slowpoke moves" />
            Location</label>
        <input id="02" type="checkbox" name="r" *ngIf="this.enabledPermissions['audio']"
            (click)="togglePermission('audio', $event)" [checked]="permissions.audio" [disabled]="permissions.audio">
        <label for="02" style="display: flex;" *ngIf="this.enabledPermissions['audio']">
            <img src="assets/images/microphone.gif" class="animated-gifs" alt="this slowpoke moves" />
            Microphone</label>
        <input id="03" *ngIf="this.enabledPermissions['video']" type="checkbox" name="r"
            (click)="togglePermission('video', $event)" [checked]="permissions.video" [disabled]="permissions.video">
        <label for="03" *ngIf="this.enabledPermissions['video']" style="display: flex;">
            <img src="assets/images/camera.gif" class="animated-gifs" alt="this slowpoke moves" />
            Camera</label>
        <input id="04" type="checkbox" name="r" [checked]="permissions.webrtc" [disabled]="permissions.webrtc">
        <label for="04" style="display: flex;">
            <img src="assets/images/browser.gif" class="animated-gifs" alt="this slowpoke moves" />
            Browser

            <mat-icon class="icon-sm browser-info material-icons-outlined" matTooltip="Tooltip!" #tooltip="matTooltip"
                (click)="tooltip.toggle()" matTooltipClass="newline"
                [matTooltip]="appLabels?.permissionsConfig?.browserSupportInfoMessage">help_outline</mat-icon>
        </label>
        <input id="05" type="checkbox" name="r" [checked]="permissions.screenshare" [disabled]="permissions.screenshare"
            *ngIf="permissions.screenshare && this.enabledPermissions['screenshare']">
        <label for="05" style="display: flex;"
            *ngIf="permissions.screenshare && this.enabledPermissions['screenshare']">
            <img src="assets/images/screenshare.gif" class="animated-gifs" alt="this slowpoke moves" />
            Screen-share</label>
    </div>

</mat-dialog-content>
<div *ngIf="!canProceed" class="alert alert-warning px-3 py-2 d-flex align-items-center">
    <mat-icon class="mr-3">warning</mat-icon><small>{{warningMessage}}</small>
</div>
<!-- actions -->
<mat-dialog-actions [ngClass]="{'flex-row-reverse' : actionsToRight}" class="flex">

    <button (click)="checkToManualProceed()"
        [disabled]="(!permissions.audio || !permissions.video || !permissions.location 
        && !locationDisabled) && !canProceed"
        mat-raised-button>
        <!-- loader -->
        <div *ngIf="proceedLoading">
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <span> {{appLabels?.permissionsConfig?.proceedLoadingMessage}}</span>
        </div>
        <div *ngIf="!proceedLoading">
            {{proceedText && proceedText !== '' ? proceedText : 'Proceed'}}
        </div>
    </button>
</mat-dialog-actions>